import { Form } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import {
  useStocksServiceGetInternalInquiryEndpoint,
  useStocksServiceGetInternalIssuanceEndpoint
} from 'src/api/queries'
import { LoadingScreen, PageBreadcrumbs } from 'src/components'
import { LocalStockIssuanceAcceptedDetails } from 'src/features/stock-local/components'
import { useFileHandler } from 'src/hooks'
import { useLocales } from 'src/locales'
import { toDayjs } from 'src/utils'

export const LocalStockIssuanceDetails = () => {
  const [form] = Form.useForm()

  const { t } = useLocales()

  const { id } = useParams()

  const { setExistingFiles } = useFileHandler({
    form,
    folder: `issuance-${id}`
  })

  const { data, isLoading } = useStocksServiceGetInternalIssuanceEndpoint(
    {
      id: String(id)
    },
    [String(id)],
    {
      enabled: !!id
    }
  )

  const { data: inquire } = useStocksServiceGetInternalInquiryEndpoint(
    {
      id: String(data?.parentDocuments?.[0]?.id)
    },
    [String(data?.parentDocuments?.[0]?.id)],
    {
      enabled: !!data
    }
  )

  useEffect(() => {
    if (data && inquire) {
      const existingFileIds = inquire?.mediaFiles
        ?.map((file) => file?.id)
        .filter(Boolean) as string[]

      setExistingFiles(existingFileIds)

      const initialFormValues = {
        documentDate: data?.documentDate
          ? dayjs(data?.documentDate)
          : undefined,
        docs: existingFileIds.map((id) => ({
          uid: id,
          name: `File-${id}`,
          status: 'done'
        })),
        medicine: inquire?.items?.map((item) => ({
          name: `${item?.internationalName?.name} ${item?.internationalName?.dosage}`,
          internationalNameId: item?.internationalName?.id,
          form: {
            name: item?.productForm?.name,
            id: item?.productForm?.id
          },
          quantity: item?.quantity,
          items: item?.roleStocks || []
        })),
        inquiryItems: data?.items?.map((issuanceItem) => ({
          inquiryItemId: issuanceItem?.id,
          name: `${issuanceItem?.internationalName?.name} ${issuanceItem?.internationalName?.dosage}`,
          producer: issuanceItem?.producer?.name,
          expirationDate: toDayjs(issuanceItem?.expirationDate),
          barCode: issuanceItem?.barCode,
          quantity: issuanceItem?.quantity,
          unit: {
            name: issuanceItem.productForm?.name,
            id: issuanceItem?.productForm?.id
          }
        }))
      }

      form.setFieldsValue(initialFormValues)
    }
  }, [data, inquire])

  if (isLoading && !data && !inquire) {
    return <LoadingScreen />
  }

  return (
    <PageBreadcrumbs
      title={t('stock_applications.liberation_document')}
      items={[
        { title: t('menu.consumable_medicaments') },
        { title: t('stock.applications') },
        {
          title: t('stock_applications.liberation_document')
        }
      ]}
    >
      <Form form={form} layout="vertical" disabled>
        <LocalStockIssuanceAcceptedDetails
          data={data}
          inquireData={inquire}
          form={form}
        />
      </Form>
    </PageBreadcrumbs>
  )
}
